import { useMatches } from 'react-router';

import { type SerializeFrom } from '~/types/serialize-from';

import type { loader as rootLoader } from '../../../root-loader';

import type { Route } from './+types/route';
import singleTierLoader from './landing-page-single-tier/loader.server';
import { loader as twoTierLoader } from './landing-page-two-tier/loader.server';
import LandingPageSingleTier from './landing-page-single-tier';
import LandingPageTwoTier from './landing-page-two-tier';

export { meta } from './landing-page-single-tier';

export async function loader(args: Route.LoaderArgs) {
  const repub = args.context.repub;

  if (repub === 'OC') {
    return twoTierLoader(args);
  }

  return singleTierLoader(args);
}

export default function OddscheckerPlus() {
  const matches = useMatches();
  const rootMatch = matches.find(match => /oddschecker-plus\/root$/.test(match.id));
  const rootLoaderData = rootMatch?.data as SerializeFrom<typeof rootLoader>;
  if (!rootLoaderData) {
    throw new Error('Root loader data is missing');
  }

  if (rootLoaderData.repub === 'OC') {
    return <LandingPageTwoTier />;
  }

  return <LandingPageSingleTier />;
}
